// extracted by mini-css-extract-plugin
export default {"wrapper":"FHuroWgO_e11I4kJMkZz","breadcrumb":"pcVNkBTwsXytSkft79Aj"};